import React from 'react';
import { motion } from 'framer-motion';

export default function PrivacyPolicy() {
  const sections = [
    {
      title: "Data Collection",
      icon: "📊",
      content: "We collect information you provide directly to us when you request a quote for enterprise servers, networking solutions, or B2B IT support. This includes your name, company email, and contact number."
    },
    {
      title: "Usage of Information",
      icon: "⚙️",
      content: "The data collected is used solely to provide tailored IT infrastructure services, manage your B2B account, and send technical updates regarding your AMC (Annual Maintenance Contract) or hardware support."
    },
    {
      title: "Device & App Data",
      icon: "🤖",
      content: "When using the PC World Raipur Downloadable App (APK), we may collect basic device information to ensure compatibility with our diagnostic tools and technical support portal."
    },
    {
      title: "Information Sharing",
      icon: "🛡️",
      content: "PC World Raipur does not sell or lease your business data to third parties. Information is only shared with authorized hardware partners (like Dell, HP, or Cisco) when required for warranty and enterprise licensing."
    },
    {
      title: "Data Security",
      icon: "🔐",
      content: "We implement industry-standard encryption and physical security measures at our Nagdev Plaza facility to protect your sensitive corporate data from unauthorized access."
    }
  ];

  return (
    <div className="bg-white min-h-screen pt-12 pb-20 px-6">
      <div className="max-w-4xl mx-auto">
        
        {/* HEADER SECTION */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <span className="text-blue-600 font-black uppercase tracking-[0.4em] text-[10px] mb-4 block">
            Legal Transparency
          </span>
          <h1 className="text-5xl md:text-6xl font-black text-slate-900 uppercase italic tracking-tighter">
            Privacy <span className="text-blue-600 underline decoration-slate-200">Policy</span>
          </h1>
          <p className="text-slate-500 mt-6 font-medium max-w-xl mx-auto">
            Your trust is our most valuable asset. Learn how PC World Raipur handles your enterprise data with absolute integrity.
          </p>
        </motion.div>

        {/* CONTENT GRID */}
        <div className="grid gap-6">
          {sections.map((section, index) => (
            <motion.div
              key={section.title}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group p-8 rounded-3xl border border-slate-100 bg-slate-50/50 hover:bg-white hover:shadow-2xl hover:shadow-blue-500/5 transition-all duration-500"
            >
              <div className="flex items-start gap-6">
                <div className="w-12 h-12 rounded-2xl bg-white shadow-sm flex items-center justify-center text-xl group-hover:scale-110 transition-transform">
                  {section.icon}
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-black text-slate-900 uppercase tracking-tight mb-3">
                    {section.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed font-medium text-sm md:text-base">
                    {section.content}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* FOOTER NOTE */}
        <motion.div 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          className="mt-16 p-8 rounded-[2.5rem] bg-slate-900 text-center"
        >
          <h4 className="text-white font-bold mb-2">Have questions about your data?</h4>
          <p className="text-slate-400 text-sm mb-6">Our compliance team is here to help.</p>
          <a 
            href="mailto:salesraipur@pcworldraipur.in" 
            className="inline-block bg-blue-600 text-white px-8 py-3 rounded-full font-black text-[11px] uppercase tracking-widest hover:bg-white hover:text-blue-600 transition-colors"
          >
            Contact Compliance ✉️
          </a>
        </motion.div>

      </div>
    </div>
  );
}